import React from 'react';
import { DisplayXS, TextSMRegular } from 'styleguide/Texts';
import { FlexColumn } from 'styleguide/Column';
import { View } from 'styleguide/View';
import { colors } from 'styleguide/colors';
import { Spacing } from 'styleguide/spacing';
import styled from 'styled-components';

import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import Image from 'next/image';
import { Card } from 'styleguide/Card';
import { CustomizableIcon } from 'styleguide/CustomizableIcon';

import FeatureClients from './feature-clients.png';
import FeaturePrograms from './feature-programs.png';
import FeatureProgress from './feature-progress.png';
import JackedVegansImage from './jacked_vegans.png';
import CirqueImage from './cirque.png';
import ElevatedCoachingImage from './elevated_coaching.png';
import PeakPerformerImage from './peak_performer.png';
import { PrimaryButton } from 'styleguide/Buttons';
import { FlexRow } from 'styleguide/Row';
import { scrollToAnchor } from 'utils/scrollToAnchor';
import { sendEvent } from 'utils/analyticsEvents';

// Makes it feel a bit more infinite
const NUMBER_OF_COACH_SLIDE_LOOPS = 4;

const UsedByCard = ({ ImageRef }: { ImageRef: any }) => {
  return (
    <Card
      style={{
        width: 180,
        height: 96,
        alignContent: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}
    >
      <Image
        src={ImageRef}
        style={{ width: '100%', objectFit: 'contain', height: '100%' }}
        alt={''}
      />
    </Card>
  );
};

const IncludedItem = ({ itemName }: { itemName: string }) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <View style={{ paddingRight: Spacing.md }}>
        <CustomizableIcon type="check" tint={colors.neutral900} />
      </View>
      {itemName}
    </View>
  );
};

const MarketingImage = ({ ImageRef }: { ImageRef: any }) => {
  return (
    <View style={{ paddingLeft: Spacing.md, paddingRight: Spacing.md, paddingTop: Spacing.md }}>
      <View
        style={{
          width: '100%',
          aspectRatio: '1.53293413',
          flex: 1,
          display: 'flex',
          boxSizing: 'border-box',
        }}
      >
        <Image
          src={ImageRef}
          alt={''}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </View>
    </View>
  );
};

const MarketingHeader = styled(DisplayXS)`
  margin-left: ${Spacing.md}px;
  margin-right: ${Spacing.md}px;
  padding-top: ${Spacing.lg}px;
  text-align: left;
  align-self: flex-start;
`;

const GreyContentContainer = styled.div`
  background-color: ${colors.neutral150};
  padding-top: ${Spacing.lg}px;
  padding-bottom: ${Spacing.lg}px;
  align-self: flex-start;
  box-sizing: border-box;
`;

const EmblaSlide = styled.div`
  flex: 0 0 228px;
  min-width: 0;
  padding-left: ${Spacing.md}px;
`;
export const SignupMarketingContent = () => {
  const [emblaRef] = useEmblaCarousel({ loop: false }, [Autoplay()]);
  return (
    <>
      <GreyContentContainer id="learn-more" style={{ marginBottom: Spacing.md }}>
        <DisplayXS
          style={{
            paddingLeft: Spacing.md,
            paddingRight: Spacing.md,
            paddingBottom: Spacing.lg,
          }}
        >
          Thousands of coaches have switched to Hevy Coach, and they couldn’t be happier.
        </DisplayXS>
        <div className="embla" ref={emblaRef} style={{ overflow: 'hidden' }}>
          <div className="embla__container" style={{ display: 'flex' }}>
            {[...Array.from(Array(NUMBER_OF_COACH_SLIDE_LOOPS).keys())].map(() => {
              return (
                <>
                  <EmblaSlide>
                    <UsedByCard ImageRef={JackedVegansImage} />
                  </EmblaSlide>
                  <EmblaSlide>
                    <UsedByCard ImageRef={CirqueImage} />
                  </EmblaSlide>
                  <EmblaSlide>
                    <UsedByCard ImageRef={ElevatedCoachingImage} />
                  </EmblaSlide>
                  <EmblaSlide>
                    <UsedByCard ImageRef={PeakPerformerImage} />
                  </EmblaSlide>
                </>
              );
            })}
          </div>
        </div>
      </GreyContentContainer>
      <MarketingHeader>Managing your clients has never been easier</MarketingHeader>
      <MarketingImage ImageRef={FeatureClients} />
      <MarketingHeader>Build and Assign Workout Programs</MarketingHeader>
      <MarketingImage ImageRef={FeaturePrograms} />
      <MarketingHeader>Track client progress at a glance, or in depth</MarketingHeader>
      <MarketingImage ImageRef={FeatureProgress} />
      <GreyContentContainer
        style={{ paddingLeft: Spacing.md, paddingRight: Spacing.sm, marginTop: Spacing.md }}
      >
        <DisplayXS>Start your 30 day free trial</DisplayXS>
        <TextSMRegular
          style={{
            color: colors.neutral500,
            paddingBottom: Spacing.md,
            paddingTop: Spacing.md,
          }}
        >
          What's included
        </TextSMRegular>
        <FlexColumn style={{ gap: Spacing.md }}>
          <IncludedItem itemName="Create unlimited workout programs" />
          <IncludedItem itemName="Extensive built-in exercise library" />
          <IncludedItem itemName="Create unlimited custom exercises" />
          <IncludedItem itemName="Track clients’ workouts & measurements" />
          <IncludedItem itemName="Clients get coached through Hevy app" />
          <IncludedItem itemName="Free Hevy Pro for all your clients" />
        </FlexColumn>
        <FlexRow style={{ justifyContent: 'center' }}>
          <PrimaryButton
            style={{ marginTop: Spacing.md, flex: 1, display: 'flex', alignSelf: 'center' }}
            title="Sign Up"
            onClick={() => {
              sendEvent('signup-ad_signupAtBottom_Clicked');
              scrollToAnchor('signup-card', 'start');
            }}
          />
        </FlexRow>
      </GreyContentContainer>
    </>
  );
};
